import React, { useContext } from "react";

export const enum V2GuideEditorContextProviderType {
  GUIDE = "Guide",
  GUIDE_TEMPLATE = "GuideTemplate",
  JOB_ROLE_GUIDE_TEMPLATE = "JobRoleGuideTemplate",
}

export interface GuideEditorInterviewPlanItem {
  id: string;
  title: string;
  description: string | null;
  position: number;
  messageCount?: number;
}

export type OverviewContentVariables = {
  companyName: string;
  jobTitle?: string;
  jobListingLink?: string;
  candidateName?: {
    firstName: string;
    lastName: string | null;
  };
  coordinatorName?: {
    firstName: string;
    lastName: string | null;
  } | null;
  recruiterName?: {
    firstName: string;
    lastName: string | null;
  };
  candidatePhone?: string | null;
  href?: string;
};

export interface V2GuideEditorContextValue {
  type: V2GuideEditorContextProviderType;
  bannerUrl: string | null;
  overviewContent: GraphQL_Json | null;
  interviewPlan: {
    items: GuideEditorInterviewPlanItem[];
  };
  id?: string;
  updateOverviewContent?: (input: {
    updatedContent: GraphQL_Json;
  }) => Promise<unknown>;
  updateBanner?: (input: { updatedBannerUrl: string }) => Promise<unknown>;
  isOverviewContentSaving?: boolean;
  isBannerSaving?: boolean;
  overviewContentVariablesData: OverviewContentVariables | undefined;
}

const V2GuideEditorContext = React.createContext<
  V2GuideEditorContextValue | undefined
>(undefined);

export const useV2GuideEditorContext = () => {
  const context = useContext(V2GuideEditorContext);
  if (context === undefined) {
    throw new Error(
      "V2EditorContext must be used within V2EditorContextProvider"
    );
  }
  return context;
};

export default V2GuideEditorContext;
